import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { resetState } from './reset-state/reset-state-reducer';
import { allSlices } from 'state/allSlices';
import { preventMaxAttemptErrorResetMiddleware } from 'state/direct-debit/direct-debit-slice';

const rootReducer = combineReducers(
  Object.entries(allSlices).reduce((acc, [sliceName, slice]) => {
    return {
      ...acc,
      [sliceName]: slice.reducer
    };
  }, {})
);

//for reset reducer; to be removed if not use it
const resetReducer = (state, action) => {
  state = resetState(state, action);

  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resetReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(
      preventMaxAttemptErrorResetMiddleware.middleware
    )
});

export type AppStore = typeof store;
// Infer the `RootState`,  `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];
